export default __webpack_public_path__ + "static/media/home-business-blog-img04.fdd21626.jpg";